import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { PromotionType } from '@atlassian/mpac-api-client';
import { promotionDetailsTabRoutes } from '@atlassian/mpac-utils';
export var PromotionDetailsTabNames = {
  DETAILS: 'Details',
  CODES: 'Codes',
  PRICING: 'Pricing'
};
export var getTabs = function getTabs(partnerId, promotionId, promotionType) {
  var links = promotionDetailsTabRoutes();
  return [{
    href: links.details.expand({
      partnerId: partnerId,
      promotionId: promotionId
    }),
    text: PromotionDetailsTabNames.DETAILS
  }].concat(_toConsumableArray(promotionType === PromotionType.SINGLE_USE_PROMOTION ? [{
    href: links.codes.expand({
      partnerId: partnerId,
      promotionId: promotionId
    }),
    text: PromotionDetailsTabNames.CODES
  }] : []), [{
    href: links.pricing.expand({
      partnerId: partnerId,
      promotionId: promotionId
    }),
    text: PromotionDetailsTabNames.PRICING
  }]);
};